export default {
    'vip':'VIP Application',
    'vipHeadSubTitle': "Please fill in the form below to apply for the official invitation of Beijing International High-tech Exop. It's issued by the organizer of Beijing International High-tech Exop, may probably but not certainly helps you obtain visa to China.",
    'company': 'Company Information',
    'cName': 'Company',
    'cPhone': 'Company Telephone',
    'cAddress': 'Company Address',
    'cEmail': 'Company Email',
    'vipInfo': 'Personal Information',
    'vipInfoTip': 'Please enter your passport number and upload the photo of  your passport before submit the application.',
    'table': {
        'Passport_number': 'Passport number',
        'Passport_photo': 'Passport photo',
        'Full_name': 'Full name (As on passport)',
        'Status': 'Status',
        'head': 'Head',
        'Sex': 'Sex',
        'Download_invitation': 'Download invitation',
        'Download_invitation2': 'Download invitation',
        'submit': 'Submit'
    },
    'vipSubTitle': 'You can download invitation card here',
    'statusText': ['Not applied', 'Pending', 'Failed to pass', 'Passed'],
    'clickUpload': 'Click upload',
    'photoTitle': 'Upload passport photo',
    'photoSubTitle': 'Please upload the first page photo of your passport here',
    'headTitle': 'Upload avatar photos',
    'headSubTitle': 'Please upload your head picture here',
    'tip1': 'Please upload the picture in jpg/png/bmp/gif format between 30kb to 1m.',
    'tip2': 'Your photo must be colored and taken within last six months.',
    'tip3': 'Please upload a clear and unobstructed photo of the front page of your passport, otherwise the organizer will ask you to upload it again',
    'uploadText': 'Click here or drag the photo to this box to upload',
    'errMsg': 'Please enter your passport number',
    'errMsg1': 'Please enter the correct passport number',
    'errMsg2': 'Please upload the first page of your passport',
    'errMsg3': 'Please upload your avatar',
    'applyNow': 'Apply now',
    'applyLater': 'Apply later',
    'applyBodyText': 'Congratulations on your successful pre registration. The system confirms that you are qualified to apply for VIP users',
    'downloadStart': 'Start downloading',
    'sex': 'Mr. / MS',
    'cardNumberEmpty': 'Chest card number is empty'
}
